const passportURL = {
    "seapiqa.azurewebsites.net": "https://sepassportqa.azurewebsites.net",
    "api.intelligentpackaging.online": "https://passport.intelligentpackaging.online",
    "se-ipa-api-prod.azurewebsites.net": "https://se-ipa-passport-prod.azurewebsites.net",
    "localhost:5000": "http://localhost:5001",
    "localhost:3000": process.env.REACT_APP_AUTH_URL,
    "core-api-qa.selflystore.com": "https://passport-qa.selflystore.com",
    "core-api.selflystore.com": "https://passport.selflystore.com",
    "core-api-staging.selflystore.com": "https://passport-staging.selflystore.com",
}

export {passportURL}


// WEBPACK FOOTER //
// ./src/config.js